import React from 'react';
import { Heading5 } from '../typography/Heading.styles';
import { RightsLink, StyledMissingContent } from './MissingContent.styles';
import PlayText from '../typography/PlayText/PlayText';

const MissingContent = ({ heading = 'Inga avsnitt tillgängliga just nu.', ...rest }) => (
    <StyledMissingContent {...rest}>
        <Heading5>{heading}</Heading5>
        <RightsLink url="https://kontakt.svt.se/guide/rattigheter">
            <PlayText as="span">Hur funkar upphovsrätt i SVT Play?</PlayText>
        </RightsLink>
    </StyledMissingContent>
);

export default MissingContent;
